module.exports = __webpack_public_path__ + "static/undraw_contact_us_15o2-759656c31b1da39032c819b3bfe365e6.svg";